/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_TitleInputs */

const en_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Preview (Magnified)`)
};

const fr_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation des sous-titres (agrandie)`)
};

const de_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelvorschau (vergrößert)`)
};

const it_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dei sottotitoli (ingrandita)`)
};

const ru_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр субтитров (увеличенный)`)
};

const es_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de subtítulos (ampliada)`)
};

const zh_cn2_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕预览（放大）`)
};

const ja_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕プレビュー（拡大）`)
};

const hi_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक पूर्वावलोकन (बड़ा करके)`)
};

const pt_pt2_video_export_magnified_title = /** @type {(inputs: Video_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da legenda (ampliada)`)
};

/**
* | output |
* | --- |
* | "Subtitle Preview (Magnified)" |
*
* @param {Video_Export_Magnified_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_title = /** @type {((inputs?: Video_Export_Magnified_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_magnified_title(inputs)
	if (locale === "de") return de_video_export_magnified_title(inputs)
	if (locale === "it") return it_video_export_magnified_title(inputs)
	if (locale === "ru") return ru_video_export_magnified_title(inputs)
	if (locale === "es") return es_video_export_magnified_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_magnified_title(inputs)
	if (locale === "ja") return ja_video_export_magnified_title(inputs)
	if (locale === "hi") return hi_video_export_magnified_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_magnified_title(inputs)
	return en_video_export_magnified_title(inputs)
});